import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'



import { WagmiConfig } from 'wagmi'
import { mainnet ,bscTestnet , goerli,base,baseGoerli } from 'wagmi/chains';
const projectId = '7d271772295fbf7a61a6f5d76baebb46';
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal Example',
  url: 'https://web3modal.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

// const chains = [bsc, polygon, mainnet ,bscTestnet,goerli,localhost]
const chains = [base ]
const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })
const queryClient = new QueryClient()

// 3. Create modal
createWeb3Modal({ wagmiConfig, projectId, chains })



const Web3Provider = ({children})=>{


return (


  <WagmiProvider config={wagmiConfig}>
  <QueryClientProvider client={queryClient}> 
    {children} 
  </QueryClientProvider> 
</WagmiProvider>

    // <WagmiConfig config={wagmiConfig}>
    // {children}
    // </WagmiConfig >
)
}


export default Web3Provider